import React from "react"
import styled from "styled-components"
import { Flex, Box, Text, Image } from "rebass"
import propTypes from "prop-types"

import withTranslation from "../i18n/withTranslation"
import instagramIcon from "../assets/instagramIcon.svg"

const Container = styled.div`
  opacity: 0.4;
  margin-top: 60px;
  transition: all 0.3s ease;

  :hover {
    opacity: 1;
  }

  a {
    text-decoration: none;
    color: black;
  }
`

const StyledLink = styled(Box)`
  a {
    text-decoration: none;
    color: black;
  }
`

const ViewMoreInstagram = ({ t }) => {
  return (
    <StyledLink>
      <Box
        sx={{
          maxWidth: [300, 350, 400],
          mx: "auto",
          px: 3,
          my: 3,
          mb: [4, 5],
        }}
      >
        <a
          href="https://www.instagram.com/balmaceda_studio/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Flex flexDirection="column" my={2}>
            <Container>
              <Box width={1} textAlign="center">
                <Image src={instagramIcon} width={["30px", "50px"]} />
              </Box>
              <Box width={1} mt={3}>
                <Text fontSize={[1, 2]} textAlign="center">
                  {t("home.instagram")}
                </Text>
              </Box>
            </Container>
          </Flex>
        </a>
      </Box>
    </StyledLink>
  )
}

ViewMoreInstagram.propTypes = {
  t: propTypes.func.isRequired,
}

export default withTranslation(ViewMoreInstagram)
